import { Button } from '@trm/ui-kit';
import { Moon02, Sun } from '@trm/ui-kit/icons';
// project import
import useConfig from '~/hooks/useConfig';
import { ThemeMode } from '~/types/config';

const ThemeModeLayout = () => {
  const { mode, onChangeMode } = useConfig();

  const handleModeChange = () => {
    onChangeMode(mode === ThemeMode.LIGHT ? ThemeMode.DARK : ThemeMode.LIGHT);
  };

  return (
    <div className="flex items-center">
      <Button
        iconLeading={
          mode === ThemeMode.DARK ? (
            <Moon02 className="text-white" data-testid="moon-icon" />
          ) : (
            <Sun data-testid="sun-icon" />
          )
        }
        size="sm"
        onClick={handleModeChange}
        className="size-9"
        color="tertiary"
        aria-label={mode === ThemeMode.LIGHT ? 'Switch to dark mode' : 'Switch to light mode'}
      />
    </div>
  );
};

export default ThemeModeLayout;
